import { RoleVariantEnum } from 'common/graphql/types';

export const DCR_DASHBOARD_PERMISSIONS = [];

export const DCR_DASHBOARD_ROLES = [
    RoleVariantEnum.SiteInvestigator,
    RoleVariantEnum.SiteCoordinator,
    RoleVariantEnum.Inspector,
    RoleVariantEnum.ProductSupport,
    RoleVariantEnum.DataChangeSupport,
];
